import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["href"];
export default /*@__PURE__*/_defineComponent({
  __name: 'SubMenus',
  props: {
    menu: {}
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_SubMenus = _resolveComponent("SubMenus", true);
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      return _openBlock(), _createBlock(_component_el_sub_menu, {
        "popper-class": "sub-menu-popper",
        index: props.menu.path
      }, {
        title: _withCtx(() => {
          var _props$menu;
          return [_createElementVNode("span", null, _toDisplayString((_props$menu = props.menu) === null || _props$menu === void 0 ? void 0 : _props$menu.title), 1)];
        }),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.menu.children, item => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: item.path
          }, [!item.children ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [!(item !== null && item !== void 0 && item.link) ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: item.path
          }, {
            default: _withCtx(() => {
              var _item$meta;
              return [_createTextVNode(_toDisplayString((_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.title), 1)];
            }),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            class: "el-menu-item"
          }, {
            default: _withCtx(() => [_createElementVNode("a", {
              class: "el-menu-link",
              href: item === null || item === void 0 ? void 0 : item.link,
              target: "_blank"
            }, _toDisplayString(item === null || item === void 0 ? void 0 : item.title), 9, _hoisted_1)]),
            _: 2
          }, 1024))], 64)) : (_openBlock(), _createBlock(_component_SubMenus, {
            key: 1,
            menu: item
          }, null, 8, ["menu"]))], 64);
        }), 128))]),
        _: 1
      }, 8, ["index"]);
    };
  }
});